export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  services: "nav-services",
  products: "nav-products",
  about: "nav-about",
  team: "nav-team",
  careers: "nav-careers",
  contact: "nav-contact",
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  headline: "hero-headline",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const CAREER = {
  jobCard: (id) => `career-job-${id}`,
  applyBtn: (id) => `career-apply-${id}`,
  applyForm: "career-apply-form",
  applyName: "career-apply-name",
  applyEmail: "career-apply-email",
  applyPhone: "career-apply-phone",
  applyCover: "career-apply-cover",
  applyResume: "career-apply-resume",
  applySubmit: "career-apply-submit",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutBtn: "admin-logout-btn",
  sidebarLink: (key) => `admin-sidebar-${key}`,
  apiLoginLink: "admin-api-login-link",
  apiLoginOpen: "admin-api-login-open",
  saveBtn: (section) => `admin-save-${section}`,
};
